import { render, staticRenderFns } from "./AdvisoryStep.vue?vue&type=template&id=28313d60&scoped=true"
import script from "./AdvisoryStep.vue?vue&type=script&lang=js"
export * from "./AdvisoryStep.vue?vue&type=script&lang=js"
import style0 from "./AdvisoryStep.vue?vue&type=style&index=0&id=28313d60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28313d60",
  null
  
)

export default component.exports